module.exports = __webpack_public_path__ + "img/sqlcEn.e8dc1907.png";